<template>
  <section>
    <!--工具条-->
    <el-col :span="24" style="padding-bottom: 0;" size="small">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-autocomplete v-model="filters.issuer" :fetch-suggestions="querySearch" size="small" placeholder="签发者"
                           :disabled="!isUser"></el-autocomplete>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="queryBtn()" size="small" icon="el-icon-search" :disabled="!isContract">
            查询
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd" size="small" icon="el-icon-plus" :disabled="!isAuth('contract:add')">新增
          </el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="contractList" highlight-current-row v-loading="listLoading" @selection-change="selsChange"
              style="width: 100%;" size="small">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column type="index" width="60" :index="indexMethod"></el-table-column>
      <el-table-column prop="account" label="用户名" width="120" align="center"></el-table-column>
      <el-table-column prop="model" label="设备类型" width="400" align="center"></el-table-column>
      <el-table-column prop="feature" label="功能" width="120" align="center"></el-table-column>
      <el-table-column prop="licence" label="licence" width="120" align="center"></el-table-column>
      <el-table-column prop="mode" label="方式" width="120" align="center">
        <template slot-scope="scope">
          <el-button type="primary" plain  size="mini"  v-if="scope.row.mode === '1'">新增</el-button>
          <el-button type="primary" plain  size="mini"  v-if="scope.row.mode === '2'">划拨</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="contract" label="合同号" width="180" align="center"></el-table-column>
      <el-table-column prop="issuer" label="签发者" width="120" align="center"></el-table-column>
      <el-table-column prop="createTime" label="生成时间" width="150" align="center"></el-table-column>
      <el-table-column label="操作" width="150" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleEdit(scope.$index, scope.row)" :disabled="!isAuth('contract:update')">编辑
          </el-button>
          <el-button type="text" size="small" @click="handleDel(scope.$index, scope.row)" :disabled="!isAuth('contract:del')">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24">
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10"
                     :total="total" :current-page.sync="page" style="float:right;">
      </el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false" width="30%">
      <el-form :model="editForm" label-width="80px" ref="editForm" :rules="editFormRules" size="small">
        <el-form-item label="方式" prop="mode">
          <el-select v-model="editForm.mode" placeholder="请选择方式" style="width:100%" :disabled="true">
            <el-option label="新增" value="1"></el-option>
            <el-option label="划拨" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户名" prop="account">
          <el-input v-model="editForm.account" auto-complete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="设备类型" prop="model">
          <el-select v-model="editForm.model" placeholder="请选择设备类型" style="width:100%" disabled>
            <el-option v-for="device in deviceList" :value="device.board" :label="device.type"
                       :key="device.board"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="功能" prop="feature">
          <el-select v-model="editForm.feature" auto-complete="off" placeholder="请选择" style="width:100%" disabled>
            <el-option v-for="func in funcList" :value="editForm.isNew===1?parseInt(func.bit):Math.pow(2,parseInt(func.bit))" :label="func.feature"
                       :key="func.bit"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="licence" prop="licence">
          <el-input v-model="editForm.licence" auto-complete="off" type="number" min="0" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="合同号" prop="contract">
          <el-input v-model="editForm.contract" auto-complete="off" type="text"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading" size="small">提交</el-button>
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog title="新增" :visible.sync="addFormVisible" :close-on-click-modal="false" width="30%">
      <el-form :model="addForm" label-width="80px" ref="addForm" size="small" :rules="addFormRules">
        <el-form-item label="方式" prop="mode">
          <el-select v-model="addForm.mode" placeholder="请选择方式"  style="width:100%">
            <el-option label="新增" value="1"></el-option>
            <el-option label="划拨" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户名" prop="account">
          <el-select v-model="addForm.account" style="width:100%">
            <el-option v-for="user in users" v-bind:value="user.value" :key="user.value">{{ user.value }}</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备类型" prop="model">
          <el-select v-model="addForm.model" placeholder="请选择设备类型" style="width:100%">
            <el-option v-for="device in deviceList" :value="device.board" :label="device.type"
                       :key="device.board"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="功能" prop="feature">
          <el-select v-model="addForm.feature" auto-complete="off" placeholder="请选择" style="width:100%">
            <el-option v-for="func in funcList" :value="parseInt(func.bit)" :label="func.feature"
                       :key="func.bit"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="licence" prop="licence">
          <el-input v-model="addForm.licence" auto-complete="off" type="number" min="0"></el-input>
        </el-form-item>
        <el-form-item label="合同号" prop="contract">
          <el-input v-model="addForm.contract" auto-complete="off" type="text"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading" size="small">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import {
  getDeviceInfo,
  getFeatureInfo,
  getContractList,
  listUsername,
  removeContract,
  addContract,
  assignContract,
  editContract, getDepotInfo, getContractInfo
} from "../../../api/api";
import { isAuth } from '../../../utils';

export default {
  data() {
    return {
      filters: {
        issuer: ""
      },
      curUser: "",
      isContract: false,
      isUser: false,
      users:[],
      contractList: [],
      issuers: [],
      deviceList: [],
      funcList: [],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列

      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      //编辑界面数据
      editForm: {
        id: "",
        account: "",
        model: "",
        feature: "",
        contract: "",
        licence: "",
        mode:"",
      },
      editFormRules: {
        account: [{
          required: true,
          message: "请选择用户",
          trigger: "change"
        }],
        model: [{
          required: true,
          message: "请选择设备类型",
          trigger: "change"
        }],
        feature: [{
          required: true,
          message: "请选择功能",
          trigger: "change"
        }],
        contract: [{
          required: true,
          message: "请输入合同号",
          trigger: "blur"
        }],
        licence: [{
          required: true,
          message: "请输入licence",
          trigger: "blur"
        },
          {
            pattern: /^([1-9]\d*|[0]{1,1})$/,
            message: "不能输入小数和负数"
          }
        ]
      },

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      //新增界面数据
      addForm: {
        account: "",
        model: "",
        feature: "",
        licence: 0,
        mode:"",
        contract:"",
      },
      addFormRules: {
        mode: [{
          required: true,
          message: "请选择方式",
          trigger: "change"
        }],
        account: [{
          required: true,
          message: "请选择用户",
          trigger: "change"
        }],
        model: [{
          required: true,
          message: "请选择设备类型",
          trigger: "change"
        }],
        feature: [{
          required: true,
          message: "请选择功能",
          trigger: "change"
        }],
        licence: [{
          required: true,
          message: "请输入licence",
          trigger: "blur"
        },
          {
            pattern: /^([1-9]\d*|[0]{1,1})$/,
            message: "不能输入小数和负数"
          }
        ]
      }
    };
  },
  methods: {
    querySearch(queryString, cb) {
      let users = this.users;
      let results = queryString ? users.filter(this.createFilter(queryString)) : users;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (user) => {
        return (user.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    indexMethod(row) {
      return row + (this.page - 1) * 10 + 1;
    },
    getUsers() {
      listUsername().then((res) => {
        this.users = res.data.userList;
      })
    },
    getDeviceInfo() {
      getDeviceInfo().then((res) => {
        this.deviceList = res.data.deviceList.content;
        this.getFeatureInfo();
      })
    },

    getFeatureInfo() {
      getFeatureInfo().then((res) => {
        this.funcList = res.data.featureList.content;
        if (this.isContract) {
          this.getContractList();
        } else {
          this.getContractInfo(this.curUser);
        }
      })
    },

    //获取仓库列表
    getContractInfo(u) {
      let para = {
        page: this.page - 1,
        size: 10,
        issuer: u
      };
      this.listLoading = true;
      getContractInfo(para).then((res) => {
        if (res.data.code === 0) {
          this.contractList = res.data.contractList.content;
          let con=[];
          for (let i = 0; i < this.contractList.length; i++) {
            // let issuer = {};
            // issuer.value = this.contractList[i].issuer;
            // this.issuers.push(issuer);
            let conMap = {};
            conMap.id = this.contractList[i].id;
            conMap.account = this.contractList[i].account;
            conMap.licence = this.contractList[i].licence;
            conMap.createTime = this.contractList[i].createTime;
            conMap.contract = this.contractList[i].contract;
            conMap.issuer = this.contractList[i].issuer;
            conMap.mode = this.contractList[i].mode.toString();
            conMap.isNew = this.contractList[i].isNew;
            for (let j = 0; j < this.deviceList.length; j++) {
              if (this.contractList[i].model === this.deviceList[j].board) {
                conMap.model = this.deviceList[j].type;
              }
            }
            for (let j = 0; j < this.funcList.length; j++) {
              if(this.contractList[i].isNew===1){
                if (this.contractList[i].feature === parseInt(this.funcList[j].bit)) {
                  conMap.feature = this.funcList[j].feature;
                }
              }else{
                if (this.contractList[i].feature === Math.pow(2, parseInt(this.funcList[j].bit))) {
                  conMap.feature = this.funcList[j].feature;
                }
              }
            }
            con.push(conMap);
          }
          this.contractList = con;
          this.total = res.data.contractList.totalElements;
        } else {
          this.$message.error("获取终端用户列表失败，请稍后重新获取");
        }
        this.listLoading = false;
      })
    },
    handleCurrentChange(val) {
      this.page = val;
      if (this.isContract) {
        this.getContractList();
      } else {
        this.getContractInfo(this.curUser);
      }
    },
    queryBtn(){
      this.page=1;
      this.getContractList();
    },

    //获取仓库列表
    getContractList() {
      let para = {
        page: this.page - 1,
        size: 10,
        issuer: this.filters.issuer
      };
      this.listLoading = true;
      getContractList(para).then((res) => {
        if (res.data.code === 0) {
          this.contractList = res.data.contractList.content;
          let con=[];
          for (let i = 0; i < this.contractList.length; i++) {
            // let issuer = {};
            // issuer.value = this.contractList[i].issuer;
            // this.issuers.push(issuer);
            let conMap = {};
            conMap.id = this.contractList[i].id;
            conMap.account = this.contractList[i].account;
            conMap.licence = this.contractList[i].licence;
            conMap.createTime = this.contractList[i].createTime;
            conMap.contract = this.contractList[i].contract;
            conMap.issuer = this.contractList[i].issuer;
            conMap.mode = this.contractList[i].mode.toString();
            conMap.isNew = this.contractList[i].isNew;
            for (let j = 0; j < this.deviceList.length; j++) {
              if (this.contractList[i].model === this.deviceList[j].board) {
                conMap.model = this.deviceList[j].type;
              }
            }
            for (let j = 0; j < this.funcList.length; j++) {
              if(this.contractList[i].isNew===1){
                if (this.contractList[i].feature === parseInt(this.funcList[j].bit)) {
                  conMap.feature = this.funcList[j].feature;
                }
              }else{
                if (this.contractList[i].feature === Math.pow(2, parseInt(this.funcList[j].bit))) {
                  conMap.feature = this.funcList[j].feature;
                }
              }
            }
            con.push(conMap);
          }
          this.contractList = con;
          this.total = res.data.contractList.totalElements;
        } else {
          this.$message.error("获取终端用户列表失败，请稍后重新获取");
        }
        this.listLoading = false;
      });
    },
    //删除
    handleDel: function (index, row) {
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning"
      }).then(() => {
        this.listLoading = true;
        let para = {
          id: row.id
        };
        removeContract(para).then((res) => {
          if (res.data.code === 0) {
            this.$message.success("删除成功");
            this.getContractList();
          } else {
            this.$message.error("删除失败");
          }
          this.listLoading = false;
        });
      }).catch(() => {

      });
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
      console.log(this.editForm);
    },
    //显示新增界面
    handleAdd: function () {
      this.addFormVisible = true;
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            for (let j = 0; j < this.deviceList.length; j++) {
              if (this.editForm.model == this.deviceList[j].type) {
                this.editForm.model = this.deviceList[j].board;
              }
            }
            for (let j = 0; j < this.funcList.length; j++) {
              if(this.editForm.isNew===1){
                if (this.editForm.feature == this.funcList[j].feature) {
                  this.editForm.feature = parseInt(this.funcList[j].bit);
                }
              }else{
                if (this.editForm.feature == this.funcList[j].feature) {
                  this.editForm.feature = Math.pow(2, parseInt(this.funcList[j].bit));
                }
              }
            }
            let para = Object.assign({}, this.editForm);
            editContract(para).then((res) => {
              if (res.data.code === 0) {
                this.$message.success("修改成功");
                this.getContractList();
              } else {
                this.$message.error("修改失败");
              }
              this.editLoading = false;
              this.$refs["editForm"].resetFields();
              this.editFormVisible = false;
            });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            let para = {
              "account": this.addForm.account,
              "model": this.addForm.model,
              "feature": this.addForm.feature,
              "licence":parseInt(this.addForm.licence),
              "mode": this.addForm.mode,
              "contract": this.addForm.contract,
              "issuer":this.curUser
            };
            const apiCall = this.addForm.mode === "1" ? addContract : assignContract;
            apiCall(para).then((res) => {
              if (res.data.code === 0) {
                this.$message.success("添加成功");
                this.getContractList();
              } else {
                this.$message.error("添加失败");
              }
              this.addLoading = false;
              this.$refs["addForm"].resetFields();
              this.addFormVisible = false;
            });
          });
        }
      });
    },
    selsChange: function (sels) {
      this.sels = sels;
    }
  },
  activated() {
    this.curUser = sessionStorage.getItem("username");
    this.isContract = isAuth("contract:list");
    this.isUser = isAuth("user:list");
    this.getUsers();
    if(!this.isContract){
      this.filters.issuer = this.curUser;
    }
    this.getDeviceInfo();
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/modules/conf/contract.vue